import { z } from 'zod';
import {
  annotationPartnerZod,
  annotationTypeZod,
} from 'packages/lib/api/annotations/contract/enums';

export const imageAnnotationZod = z.object({
  token: z.string(),
  objectToken: z.string().nullable(),
  categoryToken: z.string().nullable(),
  type: annotationTypeZod,
  imageDataToken: z.string().nullable(),
  name: z.string().nullable(),
  taskToken: z.string().nullable(),
  instructionToken: z.string().nullable(),
  attributes: z.string().nullable(),
  partner: annotationPartnerZod.optional(),
  left: z.number(),
  right: z.number(),
  top: z.number(),
  bottom: z.number(),
  height: z.number().optional(),
  width: z.number().optional(),
  polygon: z.string().nullable(),
  mask: z.string().nullable(),
  visibility: z.string().nullable(),
  tag: z.string().nullable(),
  comment: z.string().nullable(),
  className: z.string().nullable(),
  // TODO: Switch over to RecoilMutable
  _updatedFields: z.string().array().optional(),
});

export const imageAnnotationRespZod = z.array(imageAnnotationZod);

export type ImageAnnotation = z.infer<typeof imageAnnotationZod>;
export type ImageAnnotationResp = z.infer<typeof imageAnnotationRespZod>;
